// extracted by mini-css-extract-plugin
module.exports = {"text":"FooterText_text__12ANu","logo":"FooterText_logo__39i1n","forceShow":"FooterText_forceShow__1Oka1"};